'use strict';

var Debug = require('../util/debug')('fallback-old-device');
var AndroidFallback = require('./android-fallback');
var WindowsPhoneFallback = require('./windows-phone-fallback');
var VideoConfig = require('../config');

var SHOULD_PROXY_ANDROID = false;
var SHOULD_PROXY_WP = false;

module.exports = {
	create: function (api) {
		var plugins = VideoConfig.plugins;

		if (plugins.indexOf('android-fallback') === -1) {
			Debug('Using legacy "fallback-old-device" for Android');
			AndroidFallback.create(api);
			SHOULD_PROXY_ANDROID = true;
		}

		if (plugins.indexOf('windows-phone-fallback') === -1) {
			Debug('Using legacy "fallback-old-device" for WP');
			WindowsPhoneFallback.create(api);
			SHOULD_PROXY_WP = true;
		}
	},
	destroy: function (api) {
		if (SHOULD_PROXY_ANDROID) {
			AndroidFallback.destroy(api);
			SHOULD_PROXY_ANDROID = false;
		}

		if (SHOULD_PROXY_WP) {
			WindowsPhoneFallback.destroy(api);
			SHOULD_PROXY_WP = false;
		}
	}
};



// WEBPACK FOOTER //
// ./src/js/plugins/fallback-old-device.js